import { useTranslation } from 'react-i18next'
import { verifyRecaptcha } from '@/services/recaptchaService'
import { toast } from 'sonner'
import { MutableRefObject } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { getCookies } from '@/lib/utils'

export const useRecaptchaValidator = (
  recaptchaRef: MutableRefObject<ReCAPTCHA | null>
) => {
  const { t } = useTranslation()
  const cookies = getCookies()
  const validateRecaptcha = async (): Promise<boolean> => {
    if (cookies?.recaptcha !== 'enabled' || cookies?.recaptcha == undefined) {
      return true
    }

    const token = recaptchaRef.current?.getValue()

    if (!token) {
      toast.warning(t('Please complete the reCAPTCHA'))
      return false
    }
    const isValidToken = await verifyRecaptcha(token)

    if (!isValidToken?.valid) {
      toast.warning(t('Invalid reCAPTCHA token'))
      recaptchaRef?.current?.reset()
      return false
    }

    recaptchaRef?.current?.reset()
    return true
  }

  const recaptchaEnabaled = () => {
    return cookies?.recaptcha === 'enabled'
  }

  return { validateRecaptcha, recaptchaEnabaled }
}
